import { waitForFlickity } from '@utilities/theme';

if (!customElements.get('fullwidth-slider')) {
  class FullWidthSlider extends HTMLElement {
    constructor() {
      super();
      this.isDisabled = this.hasAttribute('data-disabled');
      this.waitForFlickityCleanup = null;
    }

    initializeSlider() {
      if (this.slider || this.isDisabled || !window.Flickity) return;

      this.slider = new window.Flickity(this, {
        wrapAround: true,
        pageDots: true,
        cellAlign: 'left'
      });
    }

    connectedCallback() {
      if(this.isDisabled) return;

      if (typeof waitForFlickity === 'function') {
        this.waitForFlickityCleanup = waitForFlickity(() => this.initializeSlider());
      } else if (window.Flickity) {
        this.initializeSlider();
      }
    }

    disconnectedCallback() {
      if (typeof this.waitForFlickityCleanup === 'function') {
        this.waitForFlickityCleanup();
        this.waitForFlickityCleanup = null;
      }
    }
  }

  customElements.define('fullwidth-slider', FullWidthSlider);
}
